module.exports = __webpack_public_path__ + "static/img/banner3.57941987.jpeg";